import { render } from "./CreateForm.vue?vue&type=template&id=d8c3396a&scoped=true"
import script from "./CreateForm.vue?vue&type=script&lang=js"
export * from "./CreateForm.vue?vue&type=script&lang=js"

import "./CreateForm.vue?vue&type=style&index=0&id=d8c3396a&scoped=true&lang=css"
import "./CreateForm.vue?vue&type=style&index=1&id=d8c3396a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8c3396a"]])

export default __exports__